import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import './styles/app.scss'

Vue.config.productionTip = false

/*
load remote config
 */
const remoteConfig = window.firebase.remoteConfig();
remoteConfig.settings = {
    minimumFetchIntervalMillis: 3600000,
};

remoteConfig.fetchAndActivate()
    .then(() => {
        /*
        set axios defaults
         */
        axios.defaults.headers.common['Authorization'] = `Bearer ${remoteConfig.getValue(`${process.env.VUE_APP_ENVIRONMENT}_api_token`)._value}`;
        axios.defaults.baseURL = remoteConfig.getValue(`${process.env.VUE_APP_ENVIRONMENT}_api_base`)._value

        /*
        init vue app
         */
        new Vue({
            router,
            render: h => h(App)
        }).$mount('#app')
    });


